import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Popover, PopoverBody } from 'reactstrap';

const TipPopover = ({ closeTipPopover, hotSpot, showTipPopover }) => {
  const [className, setClassName] = useState(
    'waiting-room-tip-modal clinic-tip'
  );
  const [heading, setHeading] = useState('');
  const [tip, setTip] = useState('');
  const [tipClass, setTipClass] = useState('');

  const bswHeading = 'awards';
  const clinicHeading = 'clinic';
  const helicopterHeading = 'visit preparation';
  const pharmacyHeading = 'pharmacy';
  const sunHeading = 'health';

  const bswTip = `<p>
    At Baylor Scott & White Health, we're proud to be the most award-winning non-profit health system in Texas for the third year in a row.
    </br>Some of our awards include:
  </p>
  <ul class='angle-bullets'>
    <li>U.S. News & World Report’s 2020-2021 Best Hospitals list</li>
    <li>American Nurses Credentialing Center’s Magnet&#174; and Pathway to Excellence&#174; designation for nursing excellence</li>
    <li>National Quality Forum National Quality Healthcare Award</li>
    <li>American Hospital Association Circle of Life Award</li>  
  </ul>
  </br>
  But it's not about us. It's about you and the confidence you find in turning to an award-winning health system for your family's care.
  </p>`;
  const clinicTip = `<p>
    As we enter flu season amidst the coronavirus pandemic, comparing symptoms of influenza (also known as the flu) vs. COVID-19 is one of the more common questions we face.
  </p>
  <p>
    The only way that we can tell the difference is by getting tested for both COVID-19 and the flu. This makes it especially important to monitor ourselves and children for symptoms of illness each day.
  </p>
  <p>
    If you have any questions, bring this up in your next upcoming video visit. We are happy to help.
  </p>`;

  const helicopterTip = `<p>Now that you are waiting for your video visit, you should prepare just like you would for a traditional in-person visit with your doctor.</p>
  <ul class='angle-bullets'>
  <li>Have a pen and paper for note taking</li>
  <li>Have a list of medications you take</li>
  <li>Make a list of questions for the doctor</li>
  <li>Discuss any recent symptoms that you've been experiencing</li>`;
  const pharmacyTip = `<p>
    Did you know that you can manage your BSW prescriptions through MyBSWHealth?</p>
  <p>     
    You can transfer prescriptions, request refills and more!
  </p>
  <p>  
    Additional Services include:
  </p>
  <ul class='angle-bullets'>
  <li>A variety of over-the-counter medication items and gifts</li>
  <li>Competitive medication pricing</li>
  <li>Pharmacist consultation</li>
  <li>Immunizations</li>
  <li>Drive-thru</li>
  <li>Genetic testing</li>
  </ul>`;
  const sunTip = `<p>
    Healthy habits: Take a walk outside your home while safely social distancing 6 feet away; practice mindful meditation and breathing exercises; wash your hands for 20 seconds.</br>
    Here are other healthy habits:
  </p>
  <ul class='angle-bullets'>
    <li>Have a healthy breakfast</li>
    <li>Drink water</li>
    <li>Take an exercise break</li>
    <li>Go offline</li>
    <li>Get around 8 hours of sleep</li>
  </ul>`;

  useEffect(() => {
    getTip();
  });

  const getTip = () => {
    switch (hotSpot) {
      case 'bswLandscape':
        setHeading(bswHeading);
        setTip(bswTip);
        setTipClass('bsw-landscape');
        break;
      case 'bswPortrait':
        setHeading(bswHeading);
        setTip(bswTip);
        setTipClass('bsw-portrait');
        break;
      case 'clinicLandscape':
        setHeading(clinicHeading);
        setTip(clinicTip);
        setTipClass('clinic-landscape');
        break;
      case 'clinicPortrait':
        setHeading(clinicHeading);
        setTip(clinicTip);
        setTipClass('clinic-portrait');
        break;
      case 'helicopterLandscape':
        setHeading(helicopterHeading);
        setTip(helicopterTip);
        setTipClass('helicopter-landscape');
        break;
      case 'helicopterPortrait':
        setHeading(helicopterHeading);
        setTip(helicopterTip);
        setTipClass('helicopter-portrait');
        break;
      case 'pharmacyLandscape':
        setHeading(pharmacyHeading);
        setTip(pharmacyTip);
        setTipClass('pharmacy-landscape');
        break;
      case 'pharmacyPortrait':
        setHeading(pharmacyHeading);
        setTip(pharmacyTip);
        setTipClass('pharmacy-portrait');
        break;
      case 'sunLandscape':
        setHeading(sunHeading);
        setTip(sunTip);
        setTipClass('sun-landscape');
        break;
      case 'sunPortrait':
        setHeading(sunHeading);
        setTip(sunTip);
        setTipClass('sun-portrait');
        break;
      default:
        setHeading(pharmacyHeading);
        setTip(pharmacyTip);
        setTipClass('pharmacy-landscape');
    }
    setClassName(`${tipClass}-tip`);
  };

  const popoverModifiers = {
    preventOverflow: {
      enabled: true,
    },
  };

  return (
    <Popover
      className='tip-popover'
      container='waiting-room-container'
      fade={false}
      hideArrow={true}
      isOpen={showTipPopover}
      modifiers={popoverModifiers}
      placement='auto'
      popperClassName={className}
      target={hotSpot}
    >
      <PopoverBody>
        <div className='heading-wrapper'>
          <div className='heading'>{heading}</div>
          <button
            aria-label='Close'
            className='btn btn-icon-only heading-button'
            onClick={closeTipPopover}
            title='Close'
          >
            <span className='icon-close popover-header-close-btn' />
          </button>
        </div>

        <div dangerouslySetInnerHTML={{ __html: tip }} />
      </PopoverBody>
    </Popover>
  );
};

TipPopover.defaultProps = {
  closeTipPopover: () => {},
  hotSpot: '',
  showTipPopover: false,
};

TipPopover.propTypes = {
  closeTipPopover: PropTypes.func,
  hotSpot: PropTypes.string,
  showTipPopover: PropTypes.bool,
};

export default TipPopover;
